export default "__VITE_ASSET__sm5GT95GtpDa1ssPNjYDpA__";